// Para birimi formatlayıcı - TRY
export const formatCurrency = (currencyCode, amount) => {
    return `${currencyCode} ${new Intl.NumberFormat('tr-TR').format(amount)}`;
  };

/**
 * getMarketPlaces / getEcommercePlaces thunk'ları bazen doğrudan dizi,
 * bazen { data: [] } veya iç içe BaseResult döner. .data.map hatalarını önler.
 */
export function unwrapThunkList(result) {
  if (result == null) return [];
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result?.data?.data)) return result.data.data;
  return [];
}